import React from 'react';
import './jds.css';

const CHIP_COLORS = {
  neutral: ['var(--bg-neutral-layer03)', 'var(--fg-neutral-subtle)'],
  brand: ['var(--bg-brand-subtler)', 'var(--fg-brand-strong)'],
};

// Chip mínimo para marcar um dado ao lado de outro (ex.: plataforma do cliente).
// 9px foge dos tamanhos publicados do JDS (13+): decisão de produto, só aqui.
export function JdsChip({ label, color = 'neutral' }) {
  const [background, foreground] = CHIP_COLORS[color] || CHIP_COLORS.neutral;

  return (
    <span
      className="jds-scope"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 14,
        padding: '0 var(--space-4)',
        borderRadius: 'var(--radius-extra-small, 3px)',
        background,
        color: foreground,
        fontSize: 9,
        fontWeight: 'var(--fw-medium)',
        lineHeight: 1,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
